module.exports = __webpack_public_path__ + "fe1681c7ace68b88dd16b536749fa64b.svg";